export enum TooltipId {
  error = 'error-tooltip',
  info = 'info-tooltip',
  infoClickable = 'info-clickable-tooltip',
}
